import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "../../shared/helpers/InputFieldState";

interface TextAreaProps {
    label: string;
    state: InputFieldState
    onChange?: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void;
    errorMessage?: string,
    maxLength?: number,
    cols?: number,
    rows?: number
}

/**
 * Text Input Element
 */
export class TextArea extends React.Component<TextAreaProps> {

    public static defaultProps = {
        label: "Label"
    };

    render() {
        return <label className="bold">{this.props.label}<textarea maxLength={this.props.maxLength}
                                                                   cols={this.props.cols} rows={this.props.rows}
                                                                   readOnly={this.props.state.editable === false}
                                                                   onChange={(event) => {
                                                                       this.props.onChange(event.target.value, event);
                                                                   }}
                                                                   value={this.props.state.value as string}/>
            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }
}
